import { api } from '../../shared/api/client';
import { useAsync } from '../../shared/ui/useAsync';

/** ¿Está Mi hogar (LoveHome dentro de KEORA) disponible en este servidor? (una vez por sesión) */
let enabled: Promise<boolean> | null = null;
export function useHomeEnabled(): boolean {
  const r = useAsync(() => {
    enabled ??= api.get<{ enabled: boolean }>('/hogar').then((x) => x.enabled).catch(() => false);
    return enabled;
  }, []);
  return r.status === 'ready' && r.data;
}
